// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH_LOGIN: `${API_BASE_URL}/api/auth/login`,
  AUTH_SIGNUP: `${API_BASE_URL}/api/auth/signup`,
  AUTH_TECHNICIANS: `${API_BASE_URL}/api/auth/technicians`,
  AUTH_TECHNICIANS_BY_SKILL: `${API_BASE_URL}/api/auth/technicians/by-skill`,
  AUTH_PROFILE: `${API_BASE_URL}/api/auth/update-profile`,
  AUTH_SKILLS: `${API_BASE_URL}/api/auth/update-skills`,
  AUTH_PROFILE_PIC: `${API_BASE_URL}/api/auth/upload-profile-pic`,
  AUTH_DELETE_PIC: `${API_BASE_URL}/api/auth/delete-profile-pic`,

  // Asset endpoints
  ASSETS: `${API_BASE_URL}/api/assets`,
  
  // Asset User endpoints
  ASSET_USER_ALL_ASSETS: `${API_BASE_URL}/api/asset-user/all-assets`,
  ASSET_USER: `${API_BASE_URL}/api/asset-user`,

  // Issues endpoints
  ISSUES: `${API_BASE_URL}/api/issues`,

  // Lab Admin endpoints
 
  LAB_ADMIN_ASSET_CATEGORIES: `${API_BASE_URL}/api/labAdmin/asset-categories`,
  LAB_ADMIN_SUBCATEGORIES: `${API_BASE_URL}/api/labAdmin/subcategories`,
  LAB_ADMIN_SPECIFICATIONS: `${API_BASE_URL}/api/labAdmin/specifications`,
  LAB_ADMIN_PENDING_USERS: `${API_BASE_URL}/api/labAdmin/pending-users`,
  LAB_ADMIN_APPROVED_USERS: `${API_BASE_URL}/api/labAdmin/approved-users`,
  LAB_ADMIN_ASSET_USER_REQUESTS: `${API_BASE_URL}/api/labAdmin/asset-user-requests`,
  LAB_ADMIN_APPROVED_ASSET_USERS: `${API_BASE_URL}/api/labAdmin/approved-asset-users`,
  LAB_ADMIN_APPROVE_REJECT: `${API_BASE_URL}/api/labAdmin/approve-reject`,
  LAB_ADMIN_ASSIGN_DEPARTMENT: `${API_BASE_URL}/api/labAdmin/assign-department`,
  LAB_ADMIN_USERS: `${API_BASE_URL}/api/labAdmin/users`,
  LAB_ADMIN_INVOICES: `${API_BASE_URL}/api/labAdmin/invoices`,
  LAB_ADMIN_DATA_EXPORT: `${API_BASE_URL}/api/labAdmin/download-company-data`,
  SUBSCRIPTIONS_GENERATE_OTP: `${API_BASE_URL}/api/subscriptions/otp/generate`,
  SUBSCRIPTIONS_VERIFY_OTP: `${API_BASE_URL}/api/subscriptions/otp/verify`,
  SUBSCRIPTIONS_TRIAL_USERS: `${API_BASE_URL}/api/subscriptions/trial-users`,
  SUBSCRIPTIONS: `${API_BASE_URL}/api/subscriptions`,

  // Payment endpoints
  PAYMENT_CREATE_ORDER: `${API_BASE_URL}/api/payments/create-order`,
  PAYMENT_VERIFY: `${API_BASE_URL}/api/payments/verify-payment`,
  PAYMENT_RAZORPAY_KEY: `${API_BASE_URL}/api/payments/rzp-key`,
  PAYMENT_HISTORY: `${API_BASE_URL}/api/payments/history`,

  // Super Admin endpoints
  COMPANIES: `${API_BASE_URL}/api/companies`,
  PLANS: `${API_BASE_URL}/api/plans`,

  // Departments endpoints
  DEPARTMENTS: `${API_BASE_URL}/api/departments`,
  // Contact endpoints
  CONTACT_FORM: `${API_BASE_URL}/api/contact/send`,};

export default API_BASE_URL;
